import { ApolloCache } from '@apollo/client';
import { WORLD_MAP_MARKER_FRAGMENT } from 'graphql/fragment/worldFragment';
import {
    CurrentUserWorldMaps,
    CurrentUserWorldMaps_currentUserWorldMaps
} from 'graphql/query/__generated__/CurrentUserWorldMaps';
import {
    GuidesForCurrentUserQuery,
    GuidesForCurrentUserQuery_currentUserGuides
} from 'graphql/query/__generated__/GuidesForCurrentUserQuery';
import { WorldMapMarkerStory_worldMapView_markers } from 'graphql/query/__generated__/WorldMapMarkerStory';
import { CURRENT_USER_GUIDES_QUERY } from 'graphql/query/guideQuery';
import { WORLD_MAP_CURRENT_USER_QUERY } from 'graphql/query/worldQuery';
import { uniqBy } from 'lodash';
import { PartialDeep } from 'type-fest';

export const updateWorldMapMarkerCache = (
    cache: ApolloCache<unknown>,
    data: PartialDeep<WorldMapMarkerStory_worldMapView_markers>
) => {
    cache.updateFragment<PartialDeep<WorldMapMarkerStory_worldMapView_markers>>(
        {
            id: cache.identify({
                __typename: 'WorldMapMarker',
                worldMapMarkerId: data.worldMapMarkerId
            }),
            fragment: WORLD_MAP_MARKER_FRAGMENT
        },
        (oldData) => ({ ...oldData, ...data })
    );
};

export const cacheAddCurrentUserMap = (
    cache: ApolloCache<unknown>,
    map: CurrentUserWorldMaps_currentUserWorldMaps
) => {
    const query = cache.readQuery<CurrentUserWorldMaps>(
        {
            query: WORLD_MAP_CURRENT_USER_QUERY
        },
        true
    );
    if (query) {
        cache.updateQuery<CurrentUserWorldMaps>(
            { query: WORLD_MAP_CURRENT_USER_QUERY },
            (existing) => ({
                currentUserWorldMaps: uniqBy([map, ...existing.currentUserWorldMaps], 'worldMapId')
            })
        );
    }
};

export const cacheAddCurrentUserGuide = (
    cache: ApolloCache<unknown>,
    guide: GuidesForCurrentUserQuery_currentUserGuides
) => {
    const query = cache.readQuery<GuidesForCurrentUserQuery>(
        {
            query: CURRENT_USER_GUIDES_QUERY
        },
        true
    );
    if (query) {
        cache.updateQuery<GuidesForCurrentUserQuery>(
            { query: CURRENT_USER_GUIDES_QUERY },
            (existing) => ({
                currentUserGuides: uniqBy([guide, ...existing.currentUserGuides], 'guideId')
            })
        );
    }
};
